import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../../main-page/main-page.service';
import { PipeToPiperingsManagmentComponent } from '../pipe-to-piperings-managment/pipe-to-piperings-managment.component';
import { PipeToPiperingsModel } from '../../../../models/settings/pipe-to-piperings.model';
declare var $: any;

@Component({
  selector: 'app-pipe-to-piperings-grid',
  template: `<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe to pipering?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePipeToPipering()">Delete</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isPipeToPiperingChoosen">
    <div class="input-effect">
        <input class="effect1" type="text" placeholder="">
        <label>Search</label>
        <span class="focus-border"></span>
    </div>
    <button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="createNewPipeToPipering()">Create</button>

    <table>
        <tr>
            <th *ngFor="let header of headers">{{header}}</th>
        </tr>
        <tr *ngFor="let pipeToPipeting of pipeToPieperingssGridData, let row_no = index">
            <td>{{pipeToPipeting.pipeFunctionName}}</td>
            <td>{{pipeToPipeting.pipeMaterialTypeName}}</td>
            <td>{{orientationsArray[pipeToPipeting.orientation]}}</td>
            <td class="columnWithIcons">
                <button type="button" class="btn editBtn" (click)="editPipeToPipering(pipeToPipeting)">
                    <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(pipeToPipeting)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PipeToPiperingsGridComponent implements OnInit {
  @Input() managmentComponent: PipeToPiperingsManagmentComponent;
  isPipeToPiperingsHidden = true;
  pipeToPieperingssGridData: PipeToPiperingsModel[] = [];
  orientationsArray: string[] = ['All', 'Veritcal', 'Horizontal'];
  selectedPipeToPipering: PipeToPiperingsModel;
  isPipeToPiperingChoosen: boolean = false;
  elementIndex: number;
  headers: string[] = ['Pipe function', 'Pipe material type', 'Orientation', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePipeToPiperingSubject.subscribe((value) => {
      this.pipeToPieperingssGridData = this.pipeToPieperingssGridData.filter(x => x._id !== value);
    });
    this.managmentComponent.stateSubject.subscribe((state) => {
      if (state !== null) {
        Object.assign(this.pipeToPieperingssGridData[this.elementIndex], state);
      }
      this.isPipeToPiperingChoosen = false;
    })
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPipeToPiperings().subscribe((response) => {
      this.pipeToPieperingssGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipeToPiperingsHidden = !this.isPipeToPiperingsHidden;
  }

  createNewPipeToPipering() {
    const pipeToPipering = new PipeToPiperingsModel();
    this.mainPageService.addNewPipeToPiperingIntoDb(JSON.stringify(pipeToPipering)).subscribe((response) => {
      pipeToPipering._id = response._id;
      pipeToPipering.id = response.id;
      this.pipeToPieperingssGridData.push(pipeToPipering);
      this.elementIndex = this.pipeToPieperingssGridData.indexOf(pipeToPipering);
      this.managmentComponent.showManagmentPage(pipeToPipering, true);
    });
    this.isPipeToPiperingChoosen = true;
  }

  setChoosenElement(element) {
    this.selectedPipeToPipering = {
      ...element,
    };
    this.elementIndex = this.pipeToPieperingssGridData.indexOf(element);
  };

  editPipeToPipering(element) {
    this.selectedPipeToPipering = {
      ...element,
    };
    this.elementIndex = this.pipeToPieperingssGridData.indexOf(element);
    this.managmentComponent.showManagmentPage(this.selectedPipeToPipering, false);
    this.isPipeToPiperingChoosen = true;
  }

  deletePipeToPipering() {
    this.mainPageService.removePipeToPipering(this.selectedPipeToPipering._id).subscribe((res) => { }, (error: any) => { });
    this.mainPageService.deletePipeToPiperingSubject.next(this.selectedPipeToPipering._id);
  }
}
